/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  OnDestroy,
  OnInit,
  input,
  output,
  inject,
} from '@angular/core';
import { ICoordenadas, ICliente, IFilter, IListado, IQueryParam } from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import { MapaService } from '../mapa.service';
import { ListadosService } from 'src/app/auxiliares/servicios/listados.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-flotante',
  templateUrl: './flotante.component.html',
  styleUrl: './flotante.component.scss',
  standalone: false,
})
export class FlotanteComponent implements OnInit, OnDestroy {
  private service = inject(MapaService);
  private listados = inject(ListadosService);

  readonly sirenas = input(0);
  readonly loading = input(false);
  readonly clientesChange = output<ICliente[]>();
  readonly estadoChange = output<boolean | undefined>();
  readonly mostrarSirenasChange = output<boolean>();
  readonly mostrarClientesChange = output<boolean>();

  /// Clientes
  public clientes: ICliente[] = [];
  public clientesSeleccionados: ICliente[] = [];
  public clientes$?: Subscription;

  // Mostrar
  public mostrarClientes = true;
  public mostrarSirenas = true;

  public estados = [
    { nombre: 'Online', value: true },
    { nombre: 'Offline', value: false },
  ];

  public estadoSeleccionado?: { nombre: string; value: boolean };

  readonly geocode = output<ICoordenadas>();

  public async selectDireccion(direccion: string) {
    const resp = await firstValueFrom(this.service.geocodeDireccion(direccion));
    this.geocode.emit(resp); // geocodeDireccion ya devuelve ICoordenadas
  }

  public changeCliente(clientes: ICliente[]) {
    if (clientes.length === 0) {
      this.clientesChange.emit(this.clientes);
    } else {
      this.clientesChange.emit(clientes);
    }
  }

  public changeEstado(estado: { nombre: string; value: boolean }) {
    if (!estado) {
      this.estadoChange.emit(undefined);
    } else {
      this.estadoChange.emit(estado.value);
    }
  }

  public changeMostrarClientes(event: MatSlideToggleChange) {
    this.mostrarClientesChange.emit(event.checked);
  }

  public changeMostrarSirenas(event: MatSlideToggleChange) {
    this.mostrarSirenasChange.emit(event.checked);
  }

  private async listarClientes(): Promise<void> {
    const filter: IFilter<ICliente> = {
      coordenadas: {
        $exists: true,
      },
    };
    // Filter
    const query: IQueryParam = {
      select: 'coordenadas nombre',
      filter: JSON.stringify(filter),
      sort: 'nombre',
    };

    // Query

    this.clientes$?.unsubscribe();
    this.clientes$ = this.listados
      .subscribe<IListado<ICliente>>('clientes', query)
      .subscribe((data) => {
        this.clientes = data.datos;
      });
    await this.listados.getLastValue('clientes', query);
  }

  /// HOOKS
  async ngOnInit(): Promise<void> {
    await this.listarClientes();
    this.clientesChange.emit(this.clientes);
  }

  ngOnDestroy(): void {
    this.clientes$?.unsubscribe();
  }
}
